import { render, staticRenderFns } from "./NewExample.vue?vue&type=template&id=ea8d7132&scoped=true&"
import script from "./NewExample.vue?vue&type=script&lang=js&"
export * from "./NewExample.vue?vue&type=script&lang=js&"
import style0 from "./NewExample.vue?vue&type=style&index=0&id=ea8d7132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8d7132",
  null
  
)

component.options.__file = "NewExample.vue"
export default component.exports